import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const SignUpConfirmation = ({ classes, affiliateId, history }) => {
  const goBackToSignUp = () => {
    if (affiliateId) {
      history.push(`/affiliate/${affiliateId}`);
    } else {
      history.push(`/sign-up`);
    }
  };

 const goToSignIn = () => history.push(`/login`);

  return (
    <div className={classes.container}>
      <Grid container spacing={8} className={classes.containerForm}>
        <Grid item xs={12}>
          <h2 className={classes.headerText}>Thank you for joining Qwell!</h2>

          <p className={classes.subtext}>
            A welcome email awaits you, with instructions on how to begin using
            Qwell.
          </p>

          <p className={classes.subtext}>
            Qwell is the first platform to combine the knowledge about who your
            doctor recommends with the convenience of online booking,
            transforming the doctor search and scheduling process into a
            personalized experience, just like having a doctor in the family.
          </p>

          <p className={classes.subtext}>
            Your doctor is a Qwell provider, trusted, and recommended by other
            providers for the high level of care they provide to their patients.
          </p>

          <p className={classes.subtext}>Welcome to Qwell!</p>

          {!affiliateId && (
            <p className={classes.subtext}>
              <Button
                onClick={goToSignIn}
                color="primary"
                variant="contained"
                className={classes.SubmitButton}
              >
                Sign In
              </Button>
            </p>
          )}
        </Grid>

        <Grid item xs={12}>
          <img src="/qr-code.png" alt="Qr-Code" />

          <p className={classes.subtext}>
            Scan this QR Code with your phone's camera to learn more about Qwell!
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
  },
  containerForm: {
    width: '50%',
    padding: '1rem',
    paddingTop: '90px',
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
    },
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '1.3em',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

export default withRouter(withStyles(styles)(SignUpConfirmation));
